import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import ChatWithClassification from "./ChatWithClassification";
import { setAssetBaseUrl } from "./config";

// Must run synchronously during initial script execution — document.currentScript
// is only valid here, not later inside init().
setAssetBaseUrl((document.currentScript as HTMLScriptElement | null)?.src);

// Cria o objeto ChatWidget com um método init()
export const ChatWidget = {
  init: (containerId: string = "chatbot-widget-container") => {
    const container = document.getElementById(containerId);
    if (!container) {
      console.error("❌ Container não encontrado:", containerId);
      return;
    }

    try {
      ReactDOM.createRoot(container).render(
        <React.StrictMode>
          <BrowserRouter>
            <ChatWithClassification />
          </BrowserRouter>
        </React.StrictMode>
      );
      console.log("✅ ChatWidget inicializado com sucesso!");
    } catch (error) {
      console.error("❌ Erro ao inicializar o ChatWidget:", error);
    }
  },
};

// Torna-o global para uso externo (ASP.NET, Articulate, etc.)
if (typeof window !== "undefined") {
  (window as any).ChatWidget = ChatWidget;
}

export default ChatWidget;
